<div class="language-switch">
    <ul class="lang-list">
        @for (lang of languagesOptions; track lang) {
            <li (click)="changeLanguage(lang.value)" [ngClass]="{ active: lang.value === selectedLanguage }" class="lang-item">
                {{ lang.name }}
            </li>
        }
    </ul>
</div>
